import clsx from "clsx";
import React from "react";
import { cn } from "../utils/utils";
interface IBadge {
  children: any;
  color?: string;
}
export function Badge({ children, color }: IBadge) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
        // ` bg-${color}-50 px-2 py-1 text-xs font-medium text-${color}-600 ring-1 ring-inset ring-${color}-500/10`
        // `bg-${color}-50 px-2 py-1 text-xs font-medium text-${color}-600 ring-1 ring-inset ring-${color}-500/10`
      )}
    >
      {children}
    </span>
  );
}

export function StatusBadge({ children }: any) {
  const color = "gray";

  return <Badge>{children}</Badge>;
}
